<div class="modal-header">
  <h4 class="modal-title">{{ 'chat.sidebar.newChannel' | translate }}</h4>
  <button type="button" class="btn-close" [attr.aria-label]="'chat.dialog.cancel' | translate" (click)="close()"></button>
</div>

<form [formGroup]="channelForm" (ngSubmit)="create()">
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label" for="chatChannelName">{{ 'chat.dialog.channelName' | translate }}</label>
      <div class="input-group">
        <!-- The prefix mirrors the visibility toggle below — the identity the
             channel will carry everywhere (# public, lock private). -->
        <span class="input-group-text">
          <i [ngClass]="isPrivate ? 'ri-lock-line' : 'ri-hashtag'" aria-hidden="true"></i>
        </span>
        <input
          id="chatChannelName"
          type="text"
          class="form-control"
          formControlName="name"
          maxlength="80"
          [placeholder]="'chat.dialog.channelName' | translate"
        >
      </div>
      @if (channelForm.controls.name.touched && channelForm.controls.name.invalid) {
        <span class="help-block"><small class="text-danger">{{ 'chat.dialog.nameRequired' | translate }}</small></span>
      }
    </div>

    <div class="mb-3">
      <label class="form-label" for="chatChannelDescription">{{ 'chat.dialog.channelDescription' | translate }}</label>
      <input id="chatChannelDescription" type="text" class="form-control" formControlName="description" maxlength="240">
    </div>

    <div class="mb-1">
      <label class="form-label d-block">{{ 'chat.dialog.channelType' | translate }}</label>
      <!-- The project's standard toggle (`custom-switch` + data-switch), not a
           radio pair: visibility is one binary choice. -->
      <div class="custom-switch mb-1">
        <input
          type="checkbox"
          id="chatChannelPrivate"
          data-switch="success"
          [checked]="isPrivate"
          (change)="onPrivateToggle($event)"
        />
        <label for="chatChannelPrivate">
          <span>{{ 'chat.dialog.privateToggle' | translate }}</span>
        </label>
      </div>
      <!-- Spells out what the CURRENT position means, so nobody creates a
           company-wide channel thinking it was invite-only. -->
      <span class="help-block d-block">
        <small class="text-muted">
          <i class="me-1" [ngClass]="isPrivate ? 'ri-lock-line' : 'ri-hashtag'" aria-hidden="true"></i
          >{{ (isPrivate ? 'chat.dialog.typePrivate' : 'chat.dialog.typePublic') | translate }}
        </small>
      </span>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="close()">{{ 'chat.dialog.cancel' | translate }}</button>
    <button type="submit" class="btn btn-primary" [disabled]="channelForm.invalid || submitting">
      @if (submitting) {
        <span class="spinner-border spinner-border-sm me-1" role="status"></span>
        <span>{{ 'chat.dialog.creating' | translate }}</span>
      } @else {
        <span>{{ 'chat.dialog.create' | translate }}</span>
      }
    </button>
  </div>
</form>
